import BaseTabSchema from 'root-packages/tabSchemaValidation/baseTabSchema.js'

export default class SpecialRequirementsSchema extends BaseTabSchema {
  constructor (options) {
    super(options)
    this.config = options.config
  }

  buildSchema () {
    return {
      passengers: [
        {
          specialRequests: this.specialRequests(),
        },
      ],
    }
  }
}
